const CATEGORY_KEYS = {
  MARKETING: 'marketing',
  MARKETING_LITE: 'marketingLite',
  UTILITY: 'utility',
  AUTHENTICATION: 'authentication',
  SERVICE: 'service',
}

const FREE_PRICING_TYPES = ['FREE_CUSTOMER_SERVICE', 'FREE_ENTRY_POINT']

const emptyBucket = () => ({ items: [], total: 0 })

const emptyCategories = () => ({
  marketing: emptyBucket(),
  marketingLite: emptyBucket(),
  utility: emptyBucket(),
  authentication: emptyBucket(),
  service: emptyBucket(),
  amount: 0,
})

const addToBucket = (bucket, point) => {
  bucket.items.push(point)
  // eslint-disable-next-line no-param-reassign
  bucket.total += point.volume
}

const sumCategories = (categories) =>
  categories.marketing.total +
  categories.marketingLite.total +
  categories.utility.total +
  categories.authentication.total +
  categories.service.total

/**
 * Fresh, independent day accumulator for the pricing (Mensagens) charts.
 * Never share one between days or renders: accumulating mutates it.
 */
export const createPricingDay = () => ({
  allChatCategory: emptyCategories(),
  regularChatCategory: emptyCategories(),
  freeChat: {
    businessInitiated: emptyBucket(),
    entryPoint: emptyBucket(),
    freeLevel: emptyBucket(),
    userInitiated: emptyBucket(),
    utility: emptyBucket(),
    service: emptyBucket(),
    amount: 0,
  },
})

/**
 * Adds one pricing_analytics data point to a day, mutating it.
 *
 * - allChatCategory: every pricing_type, including SERVICE (paid + free), as Meta reports.
 * - regularChatCategory: REGULAR only (paid).
 * - legacy: drops SERVICE everywhere (period before the Meta billing cutoff).
 * - freeChat: free SERVICE (customer service + entry point) and free UTILITY (customer service).
 */
export const accumulatePricingPoint = (day, point, { legacy = false } = {}) => {
  // own keys only: the category comes from the API and must not resolve to something inherited
  if (!Object.prototype.hasOwnProperty.call(CATEGORY_KEYS, point.pricing_category)) return day
  const key = CATEGORY_KEYS[point.pricing_category]
  // Before 01/10/2026 the report has no Serviço at all, free or paid
  if (legacy && key === 'service') return day

  /* eslint-disable no-param-reassign */
  addToBucket(day.allChatCategory[key], point)
  day.allChatCategory.amount = sumCategories(day.allChatCategory)

  if (point.pricing_type === 'REGULAR') {
    addToBucket(day.regularChatCategory[key], point)
    day.regularChatCategory.amount = sumCategories(day.regularChatCategory)
  }

  if (FREE_PRICING_TYPES.includes(point.pricing_type)) {
    if (key === 'service') addToBucket(day.freeChat.service, point)
    if (key === 'utility' && point.pricing_type === 'FREE_CUSTOMER_SERVICE') addToBucket(day.freeChat.utility, point)
    day.freeChat.amount = day.freeChat.utility.total + day.freeChat.service.total
  }
  /* eslint-enable no-param-reassign */

  return day
}

const withoutService = (card) => {
  if (!card) return card
  const { service = 0, total = 0 } = card
  return { ...card, service: 0, total: total - service }
}

/**
 * Legacy view of the payload cards: Serviço leaves the all and free cards (and their totals); the paid card is untouched.
 * Returns a copy; the payload is left untouched.
 */
export const adaptCategoryCardsForLegacy = (cardsCategory = {}) => {
  const { totalCategory, freeTierCategory } = cardsCategory
  return {
    ...cardsCategory,
    ...(totalCategory && { totalCategory: withoutService(totalCategory) }),
    ...(freeTierCategory && { freeTierCategory: withoutService(freeTierCategory) }),
  }
}
